export const VALIDATE_SHOPIFY_URL_SUCCESS = 'SHOPIFY/VALIDATE_SHOPIFY_URL_SUCCESS';
export const VALIDATE_SHOPIFY_URL_ERROR = 'SHOPIFY/VALIDATE_SHOPIFY_URL_ERROR';
export const CLEAR_VALIDATE_SHOPIFY_URL = 'EARNINGS/CLEAR_VALIDATE_SHOPIFY_URL';

export const CONNECT_SHOPIFY_STORE_SUCCESS = 'SHOPIFY/CONNECT_SHOPIFY_STORE_SUCCESS';
export const CONNECT_SHOPIFY_STORE_ERROR = 'SHOPIFY/CONNECT_SHOPIFY_STORE_ERROR';
export const CLEAR_CONNECT_SHOPIFY_STORE = 'EARNINGS/CLEAR_CONNECT_SHOPIFY_STORE';

export const SHOPIFY_STORE_INFO_SUCCESS = 'SHOPIFY/SHOPIFY_STORE_INFO_SUCCESS';
export const SHOPIFY_STORE_INFO_ERROR = 'SHOPIFY/SHOPIFY_STORE_INFO_ERROR';
export const CLEAR_SHOPIFY_STORE_INFO = 'EARNINGS/CLEAR_SHOPIFY_STORE_INFO';

export const DISCONNECT_SHOPIFY_STORE_SUCCESS = 'SHOPIFY/DISCONNECT_SHOPIFY_STORE_SUCCESS';
export const DISCONNECT_SHOPIFY_STORE_ERROR = 'SHOPIFY/DISCONNECT_SHOPIFY_STORE_ERROR';
export const CLEAR_DISCONNECT_SHOPIFY_STORE = 'EARNINGS/CLEAR_DISCONNECT_SHOPIFY_STORE';

export const RESYNC_SHOPIFY_STORE_SUCCESS = 'SHOPIFY/RESYNC_SHOPIFY_STORE_SUCCESS';
export const RESYNC_SHOPIFY_STORE_ERROR = 'SHOPIFY/RESYNC_SHOPIFY_STORE_ERROR';
export const CLEAR_RESYNC_SHOPIFY_STORE = 'EARNINGS/CLEAR_RESYNC_SHOPIFY_STORE';

export const SYNCHRONIZE_SHOPIFY_PRODUCTS_SUCCESS = 'SHOPIFY/SYNCHRONIZE_SHOPIFY_PRODUCTS_SUCCESS';
export const SYNCHRONIZE_SHOPIFY_PRODUCTS_ERROR = 'SHOPIFY/SYNCHRONIZE_SHOPIFY_PRODUCTS_ERROR';
export const CLEAR_SYNCHRONIZE_SHOPIFY_PRODUCTS = 'EARNINGS/CLEAR_SYNCHRONIZE_SHOPIFY_PRODUCTS';
